/*
 * @Author:
 * @LastEditTime: 2022-01-10 14:41:15
 * @Description:下载错误结果混入
 */

/**
 * This provides mixins used for common functions in the Vue components.
 * Before you begin to used it , plz inject this mixins in the components
 * like mixins: [DownResultFile]
 *
 * @mixin
 */
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()

const DownResultFile = {
  // 下载导入结果
  async exportResults() {
    const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
      returnType: 'Blob',
    })
    if (!err) {
      this.exportFileExcel(res)
    }
  },
  // 下载文件
  exportFileExcel(data) {
    const blob = new Blob([data])
    const blobUrl = window.URL.createObjectURL(blob)
    const templink = document.createElement('a')
    templink.style.display = 'none'
    templink.href = blobUrl
    templink.setAttribute('download', '导入结果.xlsx')
    document.body.appendChild(templink)
    templink.click()
    document.body.removeChild(templink)
    window.URL.revokeObjectURL(blobUrl)
    this.$message({
      showClose: true,
      message: '下载成功',
      type: 'success',
    })
  },
}
export default {
  methods: DownResultFile,
}
